import { render, staticRenderFns } from "./TicketViewInfo.vue?vue&type=template&id=52a00400&"
import script from "./TicketViewInfo.vue?vue&type=script&lang=js&"
export * from "./TicketViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports